import { Box, BoxProps, Container, Grid2, Grid2Props, Typography } from "@mui/material";
import { FC } from "react";
import { gridWrapperConstant } from "src/lib/utils/constants";
import { ContainerSize } from "src/lib/utils/types";
import components from "..";

interface SalifyGridWrapperProps {
  columnTotal: number | undefined;
  containerSize?: ContainerSize | undefined;
  cssProps: Grid2Props;
  itemCssProps: BoxProps;
  components: any[];
}

const SalifyGridWrapper: FC<SalifyGridWrapperProps> = (props) => {
  return props.containerSize === "full" || !props.containerSize ? (
    <_GridWrapper {...props} />
  ) : (
    <Container maxWidth={props.containerSize} disableGutters>
      <_GridWrapper {...props} />
    </Container>
  );
};

SalifyGridWrapper.displayName = "SalifyGridWrapper";

export default SalifyGridWrapper;

const _GridWrapper: FC<SalifyGridWrapperProps> = (props) => {
  return (
    <Grid2
      container
      columns={props.columnTotal || gridWrapperConstant.colTotal}
      spacing={props?.cssProps?.spacing ?? { mobile: 2, tablet: 3, laptop: 4 }}
      {...props.cssProps}
    >
      {props.components?.length &&
        props.components.map((item, index) => {
          const Component =
            (components as any)?.[item.blockName]?.[item.variant || "default"] ?? null;

          return (
            <Grid2
              key={index}
              size={{
                mobile: item.colSpan?.mobile || props.columnTotal || gridWrapperConstant.colTotal,
                tablet: item.colSpan?.tablet,
                laptop: item.colSpan?.laptop,
                desktop: item.colSpan?.desktop,
              }}
            >
              {Component ? (
                props.itemCssProps ? (
                  <Box key={index} {...props.itemCssProps}>
                    <Component {...item.props} />
                  </Box>
                ) : (
                  <Component key={index} {...item.props} />
                )
              ) : (
                <Typography color="red">
                  Chưa hỗ trợ component với block name: {item.blockName}
                </Typography>
              )}
            </Grid2>
          );
        })}
    </Grid2>
  );
};
